"use client";

import { useFieldDetailInfoModal } from "@/src/stores/useFieldDetailInfoModal";
import { FC } from "react";
import { FieldDetailInfoModal } from "./FieldDetailInfoModal";

export const FieldDetailInfoModalClientWrapper: FC = () => {
  const {
    description,
    title,
    actions,
    isOpen,
    close: closeFieldDetailInfoModal,
  } = useFieldDetailInfoModal((state) => state);

  return (
    <FieldDetailInfoModal
      onClose={closeFieldDetailInfoModal}
      open={isOpen}
      title={title}
      description={description}
      actions={actions}
    />
  );
};

export default FieldDetailInfoModalClientWrapper